import type { Breakpoints } from '@avensia/excite';

export const breakpoints: Breakpoints = {
  mobile: 768,
  tablet: 1280,
  laptop: Infinity,
};
